export default {
	props: {
		alwaysOn:{
			type: Boolean,
			default:false
		},
		extLabel: String, //work as label
		start: {
			type: String,
			default(){return null},
		},
		end: {
			type: String,
			default(){return null},
		},
		format:{
			type: String,
			default: 'DD.MM.YYYY',
		},
		lngLocale:{
			type: String,
			default: 'en-GB',
		},
		currencyCode:{
			type: String,
			default: '',
		},
		dpStartDate:{
			type: [ String, Date ],
			default(){ return new Date(); },
		},
		dpEndDate:{
			type: [ String, Date ],
			default(){
				const d = new Date();
				d.setDate(d.getDate() + 365*2);
				return d;
			},
		},
		dpLastDateAvailable:{
			type: [ String, Date ],
			default(){
				const d = new Date();
				d.setDate(d.getDate() + 365*2);
				return d;
			},
		},
		dpDisabledDates:{
			type: Array,
			default(){return [];},
		},
		dpPeriodDatesPrices:{
			type: Array,
			default(){return [];},
		},
	},
	data(){
		return {
			innerStart: null,
			innerEnd: null,
			validationClass: '',
			onChangeViewedMonths: getDebounceFunc((date=null)=>{
				let d1 = new Date(this.$refs.vueHotelDatepicker.paginateMonths[0].days[10].date);
				let d2 = this.$refs.vueHotelDatepicker.paginateMonths[1] ? new Date(this.$refs.vueHotelDatepicker.paginateMonths[1].days[10].date) : new Date(d1);
				this.$emit(
					'change-viewed-months',
					[
						this.dateToIso(new Date(d1.getFullYear(), d1.getMonth(), 1, 0, 0, 0, 0)),
						this.dateToIso(new Date(d2.getFullYear(), d2.getMonth(), 1, 0, 0, 0, 0))
					]
				);
			}, 1),
			translations:{
				'bg-BG': {night:'Нощувка',nights:'Нощувки',week:'Седмица',weeks:'Седмици','day-names':['Нед','Пон','Вто','Сря','Чет','Пет','Съб'],'check-in':'Настаняване','check-out':'Напускане','month-names':['Януари','Февруари','Март','Април','Май','Юни','Юли','Август','Септември','Октомври','Ноември','Декември',],tooltip:{halfDayCheckIn:'Възможно настаняване',halfDayCheckOut:'Възможно напускане',saturdayToSaturday:'Само от събота до събота',sundayToSunday:'Само от неделя до неделя',minimumRequiredPeriod:'%{minNightInPeriod} %{night} минимум.',},},
				'en-GB': {night:'Night',nights:'Nights',week:'Week',weeks:'Weeks','day-names':['Sun','Mon','Tue','Wed','Thur','Fri','Sat'],'check-in':'Check-in','check-out':'Check-out','month-names':['January','February','March','April','May','June','July','August','September','October','November','December',],tooltip:{halfDayCheckIn:'Available CheckIn',halfDayCheckOut:'Available CheckOut',saturdayToSaturday:'Only Saturday to Saturday',sundayToSunday:'Only Sunday to Sunday',minimumRequiredPeriod:'%{minNightInPeriod} %{night} minimum.',},},
				'es-ES': {night:'Noche',nights:'Noches',week:'Semana',weeks:'Semanas','day-names':['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],'check-in':'Arribo','check-out':'Partida','month-names':['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre',],tooltip:{halfDayCheckIn:'Arribo Disponible',halfDayCheckOut:'Partida Disponible',saturdayToSaturday:'Sólo Sábados a Sábados',sundayToSunday:'Sólo Domingo a Domingo',minimumRequiredPeriod:'%{minNightInPeriod} %{night} mínimo.',},},
				'fr-FR': {night:'Nuit',nights:'Nuits',week:'Semaine',weeks:'Semaines','check-in':'Départ','check-out':'Arrivée','day-names':['Lu','Ma','Me','Je','Ve','Sa','Di'],'month-names':['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre',],tooltip:{halfDayCheckIn:'Réservation possible',halfDayCheckOut:'Réservation possible',saturdayToSaturday:'Du samedi au samedi uniquement',sundayToSunday:'Du dimanche au dimanche uniquement',minimumRequiredPeriod:'%{minNightInPeriod} %{night} minimum',},},
				'it-IT': {night:'Notte',nights:'Notti',week:'Settimana',weeks:'Settimane','day-names':['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],'check-in':'Check-in','check-out':'Check-out','month-names':['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre',],tooltip:{halfDayCheckIn:'Check-in Disponibile',halfDayCheckOut:'Check-out Disponibile',saturdayToSaturday:'Solo da Sabato a Sabato',sundayToSunday:'Solo da Domenica a Domenica',minimumRequiredPeriod:'%{minNightInPeriod} %{night} minimo.',},},
				'pt-PT': {night:'Noite',nights:'Noites',week:'Semana',weeks:'Semanas','day-names':['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],'check-in':'Chegada','check-out':'Partida','month-names':['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro',],tooltip:{halfDayCheckIn:'Chegada possíveis',halfDayCheckOut:'Partida possíveis',saturdayToSaturday:'Sábado a Sábado apenas',sundayToSunday:'Domingo a domingo apenas',minimumRequiredPeriod:'%{minNightInPeriod} %{night} mínimo.',},},
			},
			isOpened: false,
		}
	},
	watch: {
		start:{
			immediate: true,
			handler(){
				if(this.innerStart!==this.start){
					this.innerStart = this.start ? this.start : null;
				}
			},
		},
		end:{
			immediate: true,
			handler(){
				if(this.innerEnd!==this.end){
					this.innerEnd = this.end ? this.end : null;
				}
			},
		},
	},
	computed:{
		disabledDates(){
			return this.dpDisabledDates;
		},
		periodDates(){
			return this.dpPeriodDatesPrices.map(v => ({
				startAt        : v.fromDate,
				endAt          : v.toDate,
				price          : v.price,
				minimumDuration: 1,
				periodType     : "nightly",
			}));
		},
		priceSymbol(){
			return this.currencyCode && typeof(getCurrencySymbol)==='function' ? getCurrencySymbol(this.currencyCode) : this.currencyCode;
		},
		cpClasses(){
			const tmp = [];
			if(this.lngLocale){
				tmp.push('dp-lng-'+this.lngLocale.toLowerCase());
			}
			if(this.currencyCode){
				tmp.push('dp-cc-'+this.currencyCode.toLowerCase());
			}
			if(this.alwaysOn){
				tmp.push('always-on');
			}
			if(this.isOpened){
				tmp.push('datepicker-opened');
			}
			return tmp.join(' ');
		},
		innerStartDate(){
			return this.innerStart ? new Date(`${this.innerStart}T00:00:00`) : null;
		},
		innerEndDate(){
			return this.innerEnd ? new Date(`${this.innerEnd}T00:00:00`) : null;
		},
	},
	methods: {
		dateToIso(date){
			return date ? `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : null;
		},
		onPeriodSelected(event, start, end) {
			this.onCheckInChanged(start);

			this.onCheckOutChanged(end);

			this.$emit('period-selected', {start:this.innerStart, end:this.innerEnd});

			this.$nextTick(()=>{ this.validate(); });
		},
		onCheckInChanged(val){
			let date = this.dateToIso(val);
			if(this.innerStart===date) return;

			this.innerStart = date;
			this.$emit('update:start', this.innerStart);
		},
		onCheckOutChanged(val){
			let date = this.dateToIso(val);
			if(this.innerEnd===date) return;

			this.innerEnd = date;
			this.$emit('update:end', this.innerEnd);
		},
		onPeriodClear(){
			this.innerStart=null;
			this.innerEnd=null;
			this.$emit('update:start', this.innerStart);
			this.$emit('update:end', this.innerEnd);
		},
		onShowCalendar(){
			this.$refs.vueHotelDatepicker.showDatepicker();
		},
		onHideCalendar(){
			this.$refs.vueHotelDatepicker.hideDatepicker();
		},
		onToggleDatepicker(){
			this.$refs.vueHotelDatepicker.toggleDatepicker();
		},
		onOpenClose(val){
			this.isOpened = val;
			this.$emit(val?'datepicker-opened':'datepicker-closed');
		},
		validate(){
			let isValid = this.innerStart && this.innerEnd;
			this.validationClass = isValid ? '' : 'invalid';
			return isValid;
		},
	},
	mounted(){
		if(this.$refs && this.$refs.vueHotelDatepicker && this.translations[this.lngLocale]){
			this.$refs.vueHotelDatepicker.i18n = this.translations[this.lngLocale];
		}
		this.onChangeViewedMonths();
	},
	template: `
<div :class="['datepicker', cpClasses, validationClass]">
	<label v-if="extLabel" class="ext-label" @click.stop.prevent="onToggleDatepicker">{{extLabel}}</label>
	<vue-hotel-datepicker
		ref="vueHotelDatepicker"
		:format="format"
		:starting-date-value="innerStartDate"
		:ending-date-value="innerEndDate"
		first-day-of-week="1"
		half-day
		:alwaysVisible="alwaysOn"
		:minNights="1"
		:startDate="dpStartDate"
		:endDate="dpEndDate"
		:lastDateAvailable="dpLastDateAvailable"
		:disableTouchEventsMonthsRender="true"
		:disabledDates="disabledDates"
		:periodDates="periodDates"
		:showPrice="!!periodDates.length"
		:priceSymbol="priceSymbol"
		:closeDatepickerOnClickOutside="true"
		@input="onOpenClose"
		@period-selected="onPeriodSelected"
		@check-in-changed="onCheckInChanged"
		@check-out-changed="onCheckOutChanged"
		@clear-selection="onPeriodClear"
		@previous-month-rendered="onChangeViewedMonths"
		@next-month-rendered="onChangeViewedMonths"
	/>
	<slot :start="innerStart" :end="innerEnd" />
</div>
`,
}
